var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _polygon, _polygon2, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "375px",
    height: "321px",
    viewBox: "0 0 375 321",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 29") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.4237745%",
    y1: "17.3952789%",
    x2: "37.3749436%",
    y2: "38.7766924%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6F97",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24334A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E9EF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7099F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-3",
    cx: 25.7715444,
    cy: 2,
    rx: 25.5737705,
    ry: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.0229723%",
    y1: "17.3952789%",
    x2: "38.8854861%",
    y2: "38.7766924%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6F97",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24334A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E9EF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7099F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-7",
    cx: 25.5737705,
    cy: 2.13157895,
    rx: 25.5737705,
    ry: 2.13157895
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6F97",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24334A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E9EF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7099F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-11",
    cx: 30.232004,
    cy: 4.05856775,
    rx: 30,
    ry: 4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "39.4160209%",
    x2: "16.2463697%",
    y2: "69.0138889%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6F97",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24334A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.379137638 L0,31.2367464 C-1.10655984e-05,33.2099219 1.43885393,34.888327 3.38886362,35.189796 C11.1948966,36.3965987 20.5550961,37 31.4694621,37 C42.0347619,37 50.4485519,36.4345778 56.7108319,35.3037333 C58.6149823,34.9598737 60,33.302348 60,31.3673989 L60,0 L60,0 L0,0.379137638 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.9594014 C4.9023394,16.9864671 15.2795764,19.5 31.1317109,19.5 C46.9838454,19.5 56.6066084,16.9864671 60,11.9594014",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-48.6%",
    width: "110.5%",
    height: "178.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -0.5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -0.5,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.447058824   0 0 0 0 0.498039216   0 0 0 0 0.650980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26375B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#243762",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "121.510174%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6D98",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#213154",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.41996507,4.9815497 L7.48832558,3.28474498 C7.98701685,3.07675414 8.54864634,3.07939069 9.04536286,3.29205443 L12.9770024,4.9753428 C13.7127292,5.29033619 14.1898354,6.01359886 14.1898354,6.81392057 L14.1898354,10.7559446 C14.1898354,11.3457876 13.929467,11.9055518 13.4783497,12.2855624 L9.27570204,15.8257745 C8.50624017,16.4739512 7.37505463,16.4496417 6.63414937,15.7690067 L2.83679706,12.2805569 C2.42450061,11.9017995 2.18983542,11.367569 2.18983542,10.8077069 L2.18983542,6.82743692 C2.18983542,6.02028737 2.67501154,5.29224996 3.41996507,4.9815497 Z",
    id: "path-20"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.2%",
    y: "-4.1%",
    width: "112.5%",
    height: "104.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-21"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E9EF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7099F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-23",
    cx: 30.232004,
    cy: 2.70571184,
    rx: 30,
    ry: 2.66666667
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.0208016%",
    y1: "35.0250124%",
    x2: "-6.36162556%",
    y2: "62.5732869%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6F97",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24334A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.358643712 L0,29.3890311 C1.01800988e-05,31.3556065 1.42951925,33.0304547 3.37168133,33.3393645 C10.3321239,34.4464548 18.6490687,35 28.3225159,35 C37.654602,35 45.1216201,34.484833 50.7235703,33.4544991 C52.6217949,33.1053593 54,31.4505519 54,29.5204858 L54,0 L54,0 L0,0.358643712 Z",
    id: "path-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E9EF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7099F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-29",
    cx: 27.2583642,
    cy: 2.70571184,
    rx: 27.0491803,
    ry: 2.66666667
  }), /*#__PURE__*/React.createElement("text", {
    id: "text-31",
    fontFamily: "LeagueSpartan-Bold, League Spartan",
    fontSize: 48,
    fontWeight: "bold",
    letterSpacing: -0.507,
    fill: "#F3F4F7"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 114,
    y: 69.6418956
  }, "5")), /*#__PURE__*/React.createElement("filter", {
    x: "-9.7%",
    y: "-2.8%",
    width: "112.9%",
    height: "104.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-32"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.37254902   0 0 0 0 0.396078431   0 0 0 0 0.466666667  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text-33",
    fontFamily: "LeagueSpartan-Bold, League Spartan",
    fontSize: 48,
    fontWeight: "bold",
    letterSpacing: -0.507,
    fill: "#F3F4F7"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 176,
    y: 61.6418956
  }, "0")), /*#__PURE__*/React.createElement("filter", {
    x: "-8.6%",
    y: "-2.8%",
    width: "111.4%",
    height: "104.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-34"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.37254902   0 0 0 0 0.396078431   0 0 0 0 0.466666667  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "49.1823487%",
    x2: "47.641963%",
    y2: "50.6487046%",
    id: "linearGradient-35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E6499",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263460",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-183.089148%",
    x2: "48.7305555%",
    y2: "234.927242%",
    id: "linearGradient-36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E6499",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263460",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text-37",
    fontFamily: "LeagueSpartan-Bold, League Spartan",
    fontSize: 48,
    fontWeight: "bold",
    letterSpacing: -0.507,
    fill: "#F3F4F7"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.19156007,
    y: 60
  }, "3")), /*#__PURE__*/React.createElement("filter", {
    x: "-9.4%",
    y: "-2.8%",
    width: "112.5%",
    height: "104.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-38"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.37254902   0 0 0 0 0.396078431   0 0 0 0 0.466666667  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text-39",
    fontFamily: "LeagueSpartan-Bold, League Spartan",
    fontSize: 48,
    fontWeight: "bold",
    letterSpacing: -0.507,
    fill: "#F3F4F7"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 61.1915601,
    y: 55
  }, "9")), /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-2.8%",
    width: "112.1%",
    height: "104.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-40"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.37254902   0 0 0 0 0.396078431   0 0 0 0 0.466666667  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-29"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,306 C74.3975502,280.543797 133.39755,272.058396 177,280.543797 C220.60245,289.029198 286.60245,280.681266 375,255.5 L375,0 L0,0 L0,306 Z",
    id: "\\u8DEF\\u5F84-83",
    fill: "#18283F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(75.000000, 135.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-22",
    transform: "translate(57.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19\\u5907\\u4EFD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.76852224 L0,68.4792165 C8.61065227e-06,70.1450155 1.03237219,71.6364309 2.59147773,72.2230109 C9.28419907,74.7410036 17.3367208,76 26.7490428,76 C35.9800611,76 43.2788442,74.789039 48.6453921,72.367117 C50.078674,71.7202844 51,70.2936854 51,68.7212066 L51,1 L51,1 L0,1.76852224 Z",
    id: "\\u8DEF\\u5F84-72",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-81",
    fill: "#34568E",
    mask: "url(#mask-4)",
    points: "29 2.67384025 -0.880349416 2.67384025 -1.6788445 -1.48450366 17.5726362 -1.48450366"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-21",
    transform: "translate(0.000000, 4.815574)",
    stroke: "#21335B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.00527131 C6.39628989,7.03813841 15.8314616,7.76329089 28.3055152,8.18072874 C41.0774999,7.88800503 48.6423281,7.52542879 51,7.09300002",
    id: "\\u8DEF\\u5F84-73"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.8473063,
    y1: -1.13686838e-13,
    x2: 9.8473063,
    y2: 7.09300002,
    id: "\\u8DEF\\u5F84-74"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.9269472,
    y1: 8.18072874,
    x2: 41.9269472,
    y2: 45.3717912,
    id: "\\u8DEF\\u5F84-75"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-22\\u5907\\u4EFD",
    transform: "translate(113.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19\\u5907\\u4EFD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.88487239 L0,73.2296298 C4.07489236e-06,74.8608997 0.9905925,76.3287386 2.50337622,76.9390886 C9.21349443,79.6463629 17.2953833,81 26.7490428,81 C36.0399241,81 43.3734279,79.6925768 48.7495541,77.0777305 C50.1262385,76.4081397 51,75.011527 51,73.4806411 L51,1.06578947 L51,1.06578947 L0,1.88487239 Z",
    id: "\\u8DEF\\u5F84-72",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-82",
    transform: "translate(0.197774, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#34568E",
    mask: "url(#mask-8)",
    points: "22.079647 2.00065737 -0.697773864 3.51549634 -1.55568497 -1.91357219 20.1448943 -1.91357219 21.0405768 -1.13464793e-13 20.1448943 1.06578947"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-21",
    transform: "translate(0.000000, 5.000000)",
    stroke: "#21335B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.39691944 C6.39628989,7.49714744 15.8314616,8.26959247 28.3055152,8.71425453 C41.0774999,8.40244014 48.6423281,8.01621762 51,7.55558698",
    id: "\\u8DEF\\u5F84-73"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.8473063,
    y1: -1.21101197e-13,
    x2: 9.8473063,
    y2: 7.55558698,
    id: "\\u8DEF\\u5F84-74"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.9269472,
    y1: 8.71425453,
    x2: 41.9269472,
    y2: 48.3308211,
    id: "\\u8DEF\\u5F84-75"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-18",
    transform: "translate(0.000000, 32.358104)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19",
    transform: "translate(12.767996, 47.583328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.232003955,4.41667217 L0.232003955,48.7744154 C0.232005429,50.6557084 1.54297736,52.2827466 3.3812237,52.6828884 C11.2351011,54.392488 20.6751819,55.2472878 31.7014661,55.2472878 C42.4281548,55.2472878 50.9371013,54.4383085 57.2283057,52.82035 C58.9961892,52.3656788 60.232004,50.7718254 60.232004,48.946411 L60.232004,3.89042023 L60.232004,3.89042023 L0.232003955,4.41667217 Z",
    id: "\\u8DEF\\u5F84-72",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-7",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-10)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#34568E",
    mask: "url(#mask-12)",
    points: "28.732004 4.05856775 0.232003955 5.98055842 -12.5359921 -6.52476008 19.4599017 -6.52476008"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19\\u5907\\u4EFD-2",
    transform: "translate(96.000000, 67.641896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-80",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-13)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    mask: "url(#mask-15)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#25365C",
    strokeWidth: 2,
    xlinkHref: "#path-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-49",
    transform: "translate(23.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2026226,3.08419321 L7.48912566,0.351235946 C8.0038841,0.1274529 8.58898802,0.130278923 9.10156077,0.359023928 L15.1947286,3.078212 C15.9154873,3.39986381 16.3796708,4.11532293 16.3796708,4.90459666 L16.3796708,11.5108153 C16.3796708,12.0863383 16.1317429,12.6339672 15.6992714,13.0136974 L9.21326632,18.7087121 C8.43358714,19.3933068 7.25985432,19.3679708 6.51044273,18.6503694 L0.616776912,13.0068716 C0.222797065,12.629615 -3.98608378e-14,12.107807 -3.90798505e-14,11.5623322 L-3.90798505e-14,4.91836585 C-3.87332778e-14,4.12208307 0.472362554,3.40166215 1.2026226,3.08419321 Z",
    id: "\\u8DEF\\u5F84-79",
    fill: "url(#linearGradient-18)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-79\\u5907\\u4EFD"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-19)",
    fillRule: "evenodd",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-21)",
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.29053715,7 C9.11896428,7 9.79053715,7.67157288 9.79053715,8.5 C9.79053715,9.1528467 9.37346907,9.70828193 8.79124012,9.91439849 L8.79053715,12 L7.79053715,12 L7.79082961,9.91475048 C7.20808066,9.70891488 6.79053715,9.15321869 6.79053715,8.5 C6.79053715,7.67157288 7.46211003,7 8.29053715,7 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#1A2844"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-22)",
    xlinkHref: "#path-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-12",
    fill: "#34568E",
    mask: "url(#mask-24)",
    points: "31.5 2.70571184 -8.8817842e-16 5.3723785 -4.14146035 0.845290486 12.3453148 -2.6276215 27.4597549 -2"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19\\u5907\\u4EFD-3",
    transform: "translate(164.000000, 59.641896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u692D\\u5706\\u5F62",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-25)",
    xlinkHref: "#path-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17,-3 C-17,4.7319865 4.04261676,11 30,11 C55.9573832,11 77,4.7319865 77,-3",
    id: "\\u8DEF\\u5F84",
    stroke: "#21335B",
    strokeWidth: 2,
    mask: "url(#mask-27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-28)",
    xlinkHref: "#path-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-11",
    fill: "#34568E",
    mask: "url(#mask-30)",
    points: "29.5 2.70571184 0.345314847 4.46539138 -3.812736 -0.643964174 11.0992327 -3.30664669"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: 5,
    fill: "#F3F4F7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-32)",
    xlinkHref: "#text-31"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#text-31"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: 0,
    fill: "#F3F4F7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-34)",
    xlinkHref: "#text-33"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#text-33"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-7",
    transform: "translate(0.232004, 41.058568)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(24.409935, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.76623899 L7.81796294,7.76623899 C11.2888566,7.68469262 15.2027914,5.60684791 19.5597672,1.53270486 C15.5970197,1.26454466 12.7897357,1.13046456 11.1379152,1.13046456 C9.80267245,3.19858926 8.50743358,4.60657511 7.25219859,5.35442209 C5.99696359,6.10226908 3.57956406,6.90620804 0,7.76623899 Z",
    id: "\\u8DEF\\u5F84-67",
    fill: "#B3B6CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81796294,7.76623899 L7.81796294,15.7099201 C11.8236986,15.5682557 14.9873916,14.4242708 17.3090419,12.2779655 C17.1977158,17.4511578 17.1977158,30.5164187 17.3090419,51.4737481 L26.0526371,50.824303 L25.9134785,1 L19.3593853,1.64380848 C17.0893415,3.68585378 15.2963217,5.04595274 13.9803257,5.72410535 C12.6643298,6.40225796 10.6102088,7.08296917 7.81796294,7.76623899 Z",
    id: "\\u8DEF\\u5F84-69",
    fill: "#F3F4F7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-71",
    fill: "#5F6577",
    points: "9.77988359 15.7099201 9.77988359 50.5447487 17.3090419 51.4737481 17.3090419 12.2779655"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-68",
    fill: "#D8D8D8",
    points: "11.1379152 1.13046456 20.4792265 0.90696681 26.0526371 1.01871568 19.5597672 1.759462"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-70",
    fill: "#7A7E9A",
    points: "0 7.76623899 0 15.0692441 7.81796294 15.7099201 7.81796294 7.76623899"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13,74.0524372 C32.252611,78.7906331 52.252611,78.7906331 73,74.0524372",
    id: "\\u8DEF\\u5F84-5",
    stroke: "url(#linearGradient-35)",
    strokeWidth: 2,
    opacity: 0.479817708,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,75.8292607 L64,64.9347354 C67.7463364,64.5843587 70.7463364,64.1271252 73,63.5630349",
    id: "\\u8DEF\\u5F84-6",
    stroke: "url(#linearGradient-36)",
    strokeWidth: 2,
    opacity: 0.479817708,
    style: {
      mixBlendMode: "multiply"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-9",
    fill: "#515768",
    points: "119.000914 28.9733874 121.026008 30.0799912 117.611078 51.3438979 115.588957 50.1418956"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-10",
    fill: "#8A90A2",
    points: "120.118847 57.2337294 122.042744 58.3371555 114.914248 61.7864389 112.898787 60.721803"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23",
    transform: "translate(68.808440, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    fill: "#F3F4F7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-38)",
    xlinkHref: "#text-37"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#text-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: 9,
    fill: "#F3F4F7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-40)",
    xlinkHref: "#text-39"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#text-39"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,50.0828332 L2.01921333,51.0691927 C3.13731573,53.6743717 4.43413677,55.6010054 5.90967646,56.849094 C7.38521615,58.0971825 9.25812151,59.1474845 11.5283926,60 L7.64416379,58.4620147 C3.94124972,56.9958221 1.12103075,53.9044275 0,50.0828332 L0,50.0828332 L0,50.0828332 Z",
    id: "\\u8DEF\\u5F84-78",
    fill: "#42485A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-76",
    fill: "#5F6577",
    points: "13.1246209 35.3634974 15.2307737 36.2945387 15.1138332 42.191914 13.1246209 41.1956893"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-77",
    fill: "#5F6577",
    points: "4.54747351e-13 50.0828332 2.01921333 51.0691927 10.3382906 46.9422001 8.27178915 45.9756857"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-8",
    fill: "#5F6577",
    points: "64.5342283 53.9405215 66.468981 55.0006574 69.6915601 51.0864278"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetPin);
export default __webpack_public_path__ + "static/media/set-pin.11227fd2930917572e8e78c526bcd72e.svg";
export { ForwardRef as ReactComponent };